import { enums, Infer, optional, string, type } from "superstruct";
import { OfferErrorStruct } from "@/shared/types/OfferErrorType";
import { OfferConfigStruct } from "@/shared/types/OfferConfigType";
import { ENVIRONMENT } from "@motain/web-shared-hub/constants";

export const EnvironmentStruct = enums(Object.values(ENVIRONMENT));

export type EnvironmentType = Infer<typeof EnvironmentStruct>;

export interface GetOfferApiProps {
  locale: string;
  offerId: string;
  environment?: EnvironmentType;
}

export const GetOfferErrorResponseStruct = type({
  error: OfferErrorStruct,
});

export type GetOfferErrorResponseType = Infer<
  typeof GetOfferErrorResponseStruct
>;

export const GetOfferResponseStruct = type({
  data: type({
    offer: OfferConfigStruct,
    access_token: string(),
    currency: optional(string()),
  }),
});

export type GetOfferResponseType = Infer<typeof GetOfferResponseStruct>;
